import React, { createContext, useContext } from "react";
import { db } from "../lib/instant";

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const { isLoading, user, error } = db.useAuth();
  
  const signUp = async (email, password, name, phone) => {
    await db.auth.signUp({ email, password });
    // Store extra profile info after sign up
    // Will be handled via InstantDB transactions
  };

  const signIn = async (email, password) => {
    await db.auth.signInWithEmail({ email, password });
  };

  const signOut = async () => {
    await db.auth.signOut();
  };

  const sendMagicCode = async (email) => {
    await db.auth.sendMagicCode({ email });
  };

  const signInWithMagicCode = async (email, code) => {
    await db.auth.signInWithMagicCode({ email, code });
  };

  return (
    <AuthContext.Provider value={{ user, isLoading, error, signUp, signIn, signOut, sendMagicCode, signInWithMagicCode }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
